exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DigestsPage .searchControls{display:flex;flex-direction:row;align-items:center;justify-content:center;gap:2rem}.DigestsPage .entityControls{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:1rem;gap:10rem}.DigestsPage .entityControls .titleContainer{display:flex}.DigestsPage .entityControls .titleContainer .removalBtn{padding-top:2.4rem;margin-left:1rem}.DigestsPage .entityControls .titleContainer .removalBtn:hover{cursor:pointer}.DigestsPage .entityControls .btnContainer{display:flex;gap:1rem}.DigestsPage .idInput{width:20%}.DigestsPage .scrollable{overflow:scroll;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/digests_page.scss
// module id = 821
// module chunks = 0